import React, { Component } from "react";
import store from "@/redux/store";

import * as CustomerConst from "actions/customerConst";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import FieldGroup from '@/views/base/Fields/Group';
import { useTranslation, withTranslation, Trans } from "react-i18next";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

interface ContactProps {
    data: any;
    state: any;
    [key: string]: any; //Accept any property
}

export function ContactPanel({ ...props }: ContactProps) {   
    const { t, i18n, ready } = useTranslation();



let index = 0;
let registerKey = "props.registerkey";
  return (
    <>
          <div className="">
            <div className="space-y-8 pb-12 sm:space-y-0   sm:pb-0">


                <div className="grid grid-cols-12 gap-3">

                <FieldHolder colspan="12" smcolspan="4" error={props?.state?.error ?? null}>
                    <FieldGroup data={props?.data} settings={props?.settings} group="phone" min="1" title="Telefoon en overige nummers" placeholder={t('phone.placeholder')}  />
                </FieldHolder>

                <FieldHolder colspan="12" smcolspan="4" error={props?.state?.error ?? null}>
                    <FieldGroup data={props?.data} settings={props?.settings} group="email" min="1" title="Email adressen" placeholder={t('email.placeholder')}/>
                </FieldHolder>

                <FieldHolder colspan="12" smcolspan="4" error={props?.state?.error ?? null}>
                    <FieldGroup data={props?.data} settings={props?.settings} group="other" min="1" title="Overige" placeholder={t('other.placeholder')}/>
                </FieldHolder>
            
              </div>
            </div>
          </div>
        
    </>
      );
}      

